import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  Link,
  Typography
} from '@mui/material';
import { QuoteMultiEquipment } from 'src/utils/constants/quotes';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import theme from 'src/theme';
import { formatAmount } from 'src/utils/formatAmout';
import Loading from 'src/components/Loading';
import useStyles from '../styles';

const StepOne = ({ data, handleNext, handleBack }) => {
  const { classes } = useStyles();

  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const { t } = useTranslation();

  const onNext = useCallback(async () => {
    handleNext({});
  }, [handleNext, data]);

  if (!data)
    return (
      <Box
        sx={{
          height: {
            xs: 'auto',
            md: '50vh'
          },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Loading />
      </Box>
    );

  return (
    <Box
      sx={{
        justifyContent: 'space-around',
        display: 'flex',
        flexDirection: 'column',
        height: {
          xs: 'auto',
          md: '50vh'
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column',
          height: '50%'
        }}
      >
        <Typography
          variant="h2"
          sx={{
            marginBottom: '10px',
            color: theme.palette.primary.main
          }}
        >
          {t('BUREAU_FORM.STEP_ONE.TITLE')}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            marginBottom: '10px'
          }}
        >
          {t('BUREAU_FORM.STEP_ONE.FIRST_DESCRIPTION')
            .replace(
              '{equipmentName}',
              data.equipmentName === QuoteMultiEquipment.MULTIEQUIPMENT
                ? `${t('ENUMS.QUOTE_MULTIEQUIPMENT.MULTIEQUIPMENT')}`
                : data.equipmentName
            )
            .replace('{distributorName}', data.distributorName)}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            marginBottom: '5px'
          }}
        >
          {t('BUREAU_FORM.STEP_ONE.SECOND_DESCRIPTION')
            .replace('{term}', data.term)
            .replace('{rent}', formatAmount(data.rent))}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            marginBottom: '10px',
            fontWeight: 'bold'
          }}
        >
          {t('BUREAU_FORM.STEP_ONE.DOCUMENT_REQUEST')}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '50%',
          marginTop: '10px'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
          }}
        >
          <Typography
            variant="body1"
            className={classes.subtitle}
            sx={{
              fontzSize: '10px',
              color: 'text.secondary'
            }}
          >
            {t('BUREAU_FORM.STEP_ONE.APROXIMATE_TIME')}
          </Typography>

          <FormControl
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginTop: '40px'
            }}
          >
            <Checkbox onClick={() => setAcceptedTerms(!acceptedTerms)} />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                flexWrap: 'wrap'
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  margin: '0 5px'
                }}
              >
                {t('COMMON.ACCEPT')}
              </Typography>
              <Link
                href="https://www.astrocap.com/terminos-y-condiciones"
                variant="a"
                target="_blank"
                sx={{
                  display: 'inline-block'
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    display: 'inline'
                  }}
                >
                  {t('LOGIN_VIEW.TERMS_AND_CONDITIONS')}
                </Typography>
              </Link>
              <Typography
                variant="body1"
                sx={{
                  margin: '0 5px'
                }}
              >
                y
              </Typography>
              <Link
                href="https://www.astrocap.com/privacidad"
                variant="a"
                target="_blank"
                sx={{
                  display: 'inline-block'
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    display: 'inline'
                  }}
                >
                  {t('LOGIN_VIEW.PRIVACY_POLICY')}
                </Typography>
              </Link>
            </Box>
          </FormControl>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 'bold',
              margin: '0 5px'
            }}
          >
            {t('COMMON.PRIVACY_POLICY_CLARIFICATION_TEXT')}
          </Typography>
        </Box>

        <Box
          className={classes.box}
          display="flex"
          justifyContent="space-between"
        >
          <Button
            className={classes.buttons}
            onClick={() => handleBack()}
            color="primary"
            variant="outlined"
          >
            {t('COMMON.BACK')}
          </Button>
          <Button
            className={clsx(
              classes.buttons,
              acceptedTerms && classes.buttonMain
            )}
            onClick={onNext}
            color="primary"
            variant="outlined"
            disabled={!acceptedTerms}
          >
            {t('COMMON.NEXT')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
StepOne.propTypes = {
  data: PropTypes.object,
  handleNext: PropTypes.func,
  handleBack: PropTypes.func
};

export default StepOne;
